import axiosInstance from "../axiosinstance";

/** @typedef {import("../types/attendance").AttendanceQuery} AttendanceQuery */
/** @typedef {import("../types/attendance").AttendanceResponse} AttendanceResponse */

export const attendanceQueryKey = (projectId, query) => [
  "attendance",
  projectId,
  query.page,
  query.pageSize,
  query.search || "",
  query.supervisorName || "",
  query.designation || "",
  query.attendanceStatus || "",
  query.nfcConfigured || "",
  Boolean(query.scannedByMe),
];

/**
 * @param {string} projectId
 * @param {AttendanceQuery} query
 * @param {AbortSignal} signal
 * @returns {Promise<AttendanceResponse>}
 */
export async function getProjectAttendance(projectId, query, signal) {
  const params = {
    page: query.page,
    page_size: query.pageSize,
    ...(query.search ? { search: query.search } : {}),
    ...(query.supervisorName ? { supervisor_name: query.supervisorName } : {}),
    ...(query.designation ? { designation: query.designation } : {}),
    ...(query.attendanceStatus
      ? { attendance_status: query.attendanceStatus }
      : {}),
    ...(query.nfcConfigured ? { nfc_configured: query.nfcConfigured } : {}),
    ...(query.scannedByMe ? { scanned_by_me: true } : {}),
  };

  const response = await axiosInstance.get(
    `/api/project_users/v2/attendance/${encodeURIComponent(projectId)}`,
    { params, signal },
  );
  return response.data;
}

export async function getProjectSupervisorOptions(projectId, signal) {
  const response = await axiosInstance.get(
    `/api/get_users_working_on_project/${encodeURIComponent(projectId)}`,
    { signal },
  );
  const users = Array.isArray(response.data)
    ? response.data
    : response.data?.data || response.data?.user_data || response.data?.user_project;
  return Array.isArray(users) ? users : [];
}

export async function getProjectDesignationOptions(projectId, signal) {
  const response = await axiosInstance.get(
    `/api/project_users/v2/attendance/${encodeURIComponent(projectId)}/designations`,
    { signal },
  );
  return Array.isArray(response.data?.data) ? response.data.data : [];
}

export async function getAttendanceHistory(projectId, query, signal) {
  const params = {
    user_id: query.userId,
    page: query.page,
    page_size: query.pageSize,
    ...(query.fromDate ? { from_date: query.fromDate } : {}),
    ...(query.toDate ? { to_date: query.toDate } : {}),
  };

  const response = await axiosInstance.get(
    `/api/attendance/history/${encodeURIComponent(projectId)}`,
    { params, signal },
  );
  return response.data;
}

export async function getParticipantAttendanceHistory(projectId, participantId, query, signal) {
  const response = await axiosInstance.get(
    `/api/participant-attendance/history/${encodeURIComponent(projectId)}/${encodeURIComponent(participantId)}`,
    { params: { page: query.page, page_size: 25, from_date: query.fromDate, to_date: query.toDate }, signal },
  );
  return response.data;
}
